export default __webpack_public_path__ + "static/media/login-v2-dark.e7fe27f6.svg";